// @ts-nocheck
import { ViewContainerRef } from '@angular/core';
import { maskList as MaskListDictionary } from '../../../../helpers/_old_helpers/masks/_mask.dict';

export class MaskHelper {
  private maskClass;

  constructor(masktype: string, _view: ViewContainerRef, assets: any) {
    if (!(MaskListDictionary as any)[masktype])
      console.error(
        '==> ' +
          masktype +
          ', this mask type not found in dictionary, please implement your new mask in dictionary'
      );

    this.maskClass = (MaskListDictionary as any)[masktype]
      ? new (MaskListDictionary as any)[masktype](_view, assets)
      : {};
  }

  public getIcon() {
    return this.maskClass.iconMask ? this.maskClass.iconMask() : '';
  }

  public getInsertIconValidate() {
    return this.maskClass.insertIconValidate ? this.maskClass.insertIconValidate : false;
  }

  public async formatOutputValue(valuePure) {
    return this.maskClass.formatOutput ? await this.maskClass.formatOutput(valuePure) : valuePure;
  }

  public getPureValue(value, curPosition) {
    return this.maskClass.removeMask ? this.maskClass.removeMask(value, curPosition) : value;
  }

  public getMaskedValue(value, curPosition) {
    return this.maskClass.setMask ? this.maskClass.setMask(value, curPosition) : value;
  }

  public getError() {
    return this.maskClass.getMaskErrors
      ? this.maskClass.getMaskErrors()
      : console.error('==> error not implemented', JSON.stringify(this.maskClass));
  }

  public validateAllDigit() {
    return this.maskClass.validateAllDigit === false ? this.maskClass.validateAllDigit : true;
  }

  public async validate(valuePure) {
    return this.maskClass.validate ? await this.maskClass.validate(valuePure) : true;
  }
}
